import BillingsOrderTaxiRailyRecalculateRequest, {
  BillingsOrderTaxiRailyRecalculateRequestBody,
} from "./billings-order-taxi-raily-recalculate.request";

const createBody = (
  request: BillingsOrderTaxiRailyRecalculateRequest,
): BillingsOrderTaxiRailyRecalculateRequestBody => {
  return {
    billingNodes: request.billingNodes,
    billingType: request.billingType,
    discount: request.discount,
  };
};

const billingsOrderTaxiRailyRecalculateRequestFactory = {
  createBody,
};

export default billingsOrderTaxiRailyRecalculateRequestFactory;
